import React, { Component } from 'react'
import { Wizard, Steps, Step } from 'react-albus'
import SignUpBasicInfo from '../register/basicInfo/basicInfoScreen'
import ProfilePhotoScreen from '../register/photo/profilePhotoScreen'
import PhoneScreen from '../register/phone/phoneScreen'
import RiderResumeScreen from './../../account/infoWizard/screens/riderResumeScreen'
import RiderExperienceScreen from './../../account/infoWizard/screens/riderExpScreen'
import EmailAuthScreen from '../register/confirmEmail/resendEmailAuth'
import WizardProgressDots from './wizardProgressDots'
import { Columns, Button, Header } from 'components/elements'
import {
  trackSignUpWizardScreen,
  trackSignUpWizardScreenAttempt,
  signUpScreenSkipped,
} from '../../elements/tracking/signupTracking.js'
import './signUpWizard.sass'
import animation from 'components/theme/assets/animations/whiteSuccessGrow.json'
import Lottie from 'lottie-react-web'

class ListingWizard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      augmentButton: false,
    }
    document.body.classList.add('sign-up-wizard')
  }

  basicInfoSuccess = (push, auth) => {
    this.props.afterBasicInfo()
    push()
    if (this.props.auth.state.triggeredFrom == 'conversation') {
      this.props.onSuccess()
    }
  }

  buildLastpage = (push) => {
    let locationPath = window.location.pathname

    if (locationPath.includes('payment')) {
      this.setState({
        augmentButton: true,
      })
    }
    push()
  }

  componentWillUnmount() {
    document.body.classList.remove('sign-up-wizard')
  }

  finalPage = () => {
    //alert()

    if (!this.state.augmentButton) {
      window.location.href = '/search'
    }

    this.props.onSuccess()
  }

  closeModal = () => {
    this.props.onSuccess()
  }

  render() {
    return (
      <>
        <React.Fragment>
          <Wizard
            //onNext={({step, push}) => this.validateStep(step, push)}
            render={({ step, steps, push }) => (
              <div key={step.id}>
                <Columns>
                  <Columns.Column>
                    <div>
                      <Steps step={step}>
                        <Step id="basic-info-signup">
                          <Header
                            renderAs={'h1'}
                            className="has-text-centered"
                            style={{
                              marginBottom: '1.5rem !important',
                              fontWeight: '800',
                            }}
                          >
                            WELCOME
                          </Header>
                          <SignUpBasicInfo
                            onSuccess={() => this.basicInfoSuccess(push)}
                            auth={this.props.auth}
                            stepNumber={1}
                          />
                          {this.props.showLoginLink && (
                            <div className="has-text-centered mt-4">
                              <p>Already signed up?</p>
                              <a href="/login">Login</a>
                            </div>
                          )}
                        </Step>
                        <Step id="art-pause">
                          <div className="art-pause-inner-wrapper">
                            <p className="has-text-weight-bold is-size-5 mb-3">
                              Riders and Owners love how safe and secure the
                              Twisted Road community is — and it’s important to
                              keep it that way. That’s why you’ll have to
                              quickly confirm a few details before you can rent
                              or list a motorcycle.
                            </p>
                            <Button
                              color="primary"
                              className="mb-3"
                              size="large"
                              onClick={() => {
                                trackSignUpWizardScreen({
                                  screen:
                                    'Welcome - Prompt To Complete Profile',
                                  step_number: 2,
                                })
                                push()
                              }}
                            >
                              Next: 5 Steps Left
                            </Button>
                          </div>
                        </Step>
                        <Step id="profile-photo">
                          <WizardProgressDots numDots={5} currentDot={1} />
                          <ProfilePhotoScreen
                            onSuccess={() => {
                              trackSignUpWizardScreen({
                                screen: 'Profile Photo',
                                step_number: 3,
                              })
                              push()
                            }}
                            onAttempt={(params) => {
                              trackSignUpWizardScreenAttempt(
                                'Profile Photo',
                                params,
                                3
                              )
                            }}
                            stepNumber={3}
                            onSkip={() => {
                              signUpScreenSkipped('Profile Photo', 3)
                              push()
                            }}
                            parentDescription="Sign Up Wizard"
                          />
                        </Step>
                        <Step id="phone">
                          <WizardProgressDots numDots={5} currentDot={2} />
                          <PhoneScreen
                            onSuccess={() => {
                              trackSignUpWizardScreen({
                                screen: 'Phone Screen',
                                step_number: 4,
                              })
                              push()
                            }}
                            onAttempt={(params) => {
                              trackSignUpWizardScreenAttempt(
                                'Phone Screen',
                                params,
                                4
                              )
                            }}
                            onSkip={() => {
                              signUpScreenSkipped('Phone Screen', 4)
                              push()
                            }}
                            stepNumber={4}
                            parentDescription={'Sign Up Wizard'}
                          />
                        </Step>
                        <Step id="email-heads-up">
                          <WizardProgressDots numDots={5} currentDot={3} />
                          <EmailAuthScreen
                            header={'Check your email!'}
                            showButton={true}
                            onSuccess={() => {
                              trackSignUpWizardScreen({
                                screen: 'Email Confirmation Reminder',
                                step_number: 5,
                              })
                              this.buildLastpage(push)
                            }}
                            onAttempt={(params) => {
                              trackSignUpWizardScreenAttempt(
                                'Email Confirmation Reminder',
                                params,
                                5
                              )
                            }}
                            parentDescription="Sign Up Wizard"
                            stepNumber={5}
                          />
                        </Step>
                        <Step id="resume">
                          <WizardProgressDots numDots={5} currentDot={4} />
                          <RiderResumeScreen
                            header={'Hi there!'}
                            showButton={true}
                            onSuccess={() => {
                              trackSignUpWizardScreen({
                                screen: 'A small description of yourself',
                                step_number: 6,
                              })
                              this.buildLastpage(push)
                            }}
                            onAttempt={(params) => {
                              trackSignUpWizardScreenAttempt(
                                'A small description of yourself',
                                params,
                                6
                              )
                            }}
                            parentDescription="Sign Up Wizard"
                            stepNumber={6}
                          />
                        </Step>
                        <Step id="riding-experience">
                          <WizardProgressDots numDots={5} currentDot={5} />
                          <RiderExperienceScreen
                            header={
                              'Please enter information on your riding history.'
                            }
                            showButton={true}
                            onSuccess={() => {
                              trackSignUpWizardScreen({
                                screen: 'Information on your riding history',
                                step_number: 7,
                              })
                              this.buildLastpage(push)
                            }}
                            onAttempt={(params) => {
                              trackSignUpWizardScreenAttempt(
                                'Information on your riding history',
                                params,
                                7
                              )
                            }}
                            parentDescription="Sign Up Wizard"
                            stepNumber={7}
                          />
                        </Step>
                        <Step id="success">
                          <div className="has-text-centered sign-up-success-screen">
                            <div
                              style={{ width: '400px', height: '400px' }}
                              className="has-text-centered has-image-centered"
                            >
                              <Lottie
                                options={{
                                  animationData: animation,
                                  loop: false,
                                }}
                              />
                            </div>
                            <h2 className="is-size-2 header has-text-weight-bold">
                              Congrats
                            </h2>
                            <p className="is-size-5 header subtitle has-text-white">
                              You're ready to ride the world on an amazing
                              motorcycle or share your own!
                            </p>

                            <Button
                              color="primary"
                              size="large"
                              className="has-text-weight-extra-bold"
                              onClick={() =>
                                trackSignUpWizardScreen({
                                  screen: 'Success Page - Welcome',
                                  step_number: 6,
                                  use_callback: true,
                                  callback: this.finalPage,
                                })
                              }
                            >
                              {this.state.augmentButton && <span>Thanks!</span>}
                              {!this.state.augmentButton && (
                                <span>Find Your Next Adventure</span>
                              )}
                            </Button>
                          </div>
                        </Step>
                      </Steps>
                    </div>
                  </Columns.Column>
                </Columns>
              </div>
            )}
          />
        </React.Fragment>
      </>
    )
  }
}

export default ListingWizard

ListingWizard.defaultProps = {
  onSuccess: function() {},
  afterBasicInfo: function() {},
}
